import businessListActionKeys from './businessListActionKeys';
import businessListService from './businessListService';

const businessListActions = {
  getServiceProviders({
    sortBy, limit, offset,
  }) {
    return {
      type: businessListActionKeys.GET_SERVICE_PROVIDERS,
      payload: {
        data: {
          sortBy,
          limit,
          offset,
        },
        promise: businessListService.getServiceProviders(sortBy, limit, offset),
      },
    };
  },
  getNewActivity({
    adsServiceProviderIds, leadsServiceProviderIds,
  }) {
    return {
      type: businessListActionKeys.GET_NEW_ACTIVITY,
      payload: {
        data: {
          adsServiceProviderIds,
          leadsServiceProviderIds,
        },
        promise: businessListService.getNewActivity(adsServiceProviderIds, leadsServiceProviderIds),
      },
    };
  },
};

export default businessListActions;



// WEBPACK FOOTER //
// ./src/app/common/businessList/businessListActions.js